<div class="sx-help-glossary">
  <div class="sx-help-glossary__search">
    <mat-form-field class="sxh-full-width" appearance="outline">
      <input matInput placeholder="Sök" (input)="doSearch($event.target.value)" id="field_glossary_search">
      <button matSuffix class="sx-button-suffix sx-button-stripped">
        <svg>
          <use xlink:href="#baseline-search-24px" href="#baseline-search-24px" />
        </svg>
      </button>
    </mat-form-field>
  </div>

  @for(word of glossaryDisplay; track word; let i = $index){
    <div>
      @if(i === 0 || glossaryDisplay[i-1].term[0] !== word.term[0]){
        <div class="sx-help-glossary__section-title" id="letter_{{word.term[0]}}">
          {{ word.term[0].toUpperCase() }}
        </div>
      }

      <mat-expansion-panel class="sx-help-glossary__expansion-panel" [expanded]="glossaryDisplay.length === 1 || isTagFiltered">
        <mat-expansion-panel-header>
          <mat-panel-title class="sx-help-glossary__term__title" id="word_{{i}}">
            {{ word.term }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        @if(word?.description) {
          <div class="sx-help-glossary__term__description" [innerHtml]="word.description | safeHtml" id="word_content_{{i}}" appRouterLink>
          </div>
        }
      </mat-expansion-panel>
    </div>
  }
</div>
